import React, { Component } from "react";

import profile from "./images/profile.png";


class TopBar extends Component {
  render() {
    return (
      <div className="topbar">
        <div className="top-buttons">
        <button className="button-element">Indian Holidays</button>
        <button className="button">International Holidays</button>
        </div>
        <img src={profile} alt="image" className="image-profile"/>
      </div>
    );
  }
}

export default TopBar;
